// @flow
import type { FSA } from 'types/redux';
import type { RefreshTokenPayload } from 'types/user';
import { API_REQUEST } from 'middlewares/api-middleware';
import * as RequestResultCases from '../middlewares/api-middleware';


export const GOOGLE_LOGIN = 'GOOGLE_LOGIN'; // Login Via Google Auth
export function dispatchSuccessfulGoogleLogin(jwt: string) {
  return {
    type: GOOGLE_LOGIN + RequestResultCases.SUCCESS,
    payload: { jwt },
    meta: {},
  };
}


export const GRAB_LOGIN = 'GRAB_LOGIN'; // Login Via Concedo
export function grabLogin(password: string): FSA {
  return {
    type: GRAB_LOGIN,
    payload: {
      method: 'POST',
      url: '/login',
      data: { method: 'concedo', password },
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const COOKIE_LOGIN = 'COOKIE_LOGIN';
export function cookieLogin(jwt, refreshToken) {
  return {
    type: COOKIE_LOGIN,
    payload: { jwt, refreshToken },
    meta: {},
  };
}

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export function refreshToken(jwtToken: string, refreshToken: string): FSA {
  const refreshTokenPayload: RefreshTokenPayload = { jwtToken, refreshToken };
  return {
    type: REFRESH_TOKEN,
    payload: {
      method: 'POST',
      url: '/tokens',
      data: refreshTokenPayload,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}

export const USER_LOGOUT = 'USER_LOGOUT';
export function userLogout(): FSA {
  return {
    type: USER_LOGOUT,
    payload: null,
  };
}

export const FORCE_RELOGIN = 'FORCE_RELOGIN';
export function forceRelogin(): FSA {
  return {
    type: FORCE_RELOGIN,
    payload: null,
  };
}

export const userPermissionsPath = 'authorizations';
export const GET_USER_PERMISSIONS = 'GET_USER_PERMISSIONS';
export function getUserPermissions(): FSA {
  return {
    type: GET_USER_PERMISSIONS,
    payload: {
      method: 'GET',
      url: `/${userPermissionsPath}`,
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}
